module.exports = __webpack_public_path__ + "static/media/ehealth_website_banner_desktop.fb90ea07.jpg";